import axios, { AxiosResponse } from "axios";
import axiosApi from "shared/api/axiosApi";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";
import {
  GetUsersParams, GetUsersRes,
  GetUsersLookupParams, GetUsersLookupResponse,
  GetMeUsersParams, GetMeUsersResponse,
  GetUsersWithoutPromocodesParams,
  GetUsersWithoutPromocodesResponse,
  GetUsersByUserIdParams,
  GetUsersByUserIdResponse,
  PostUsersBody,
  PostUsersResponse,
  PutUsersAsAdminBody,
  PutUsersAsAdminResponse,
  PutMeUsersBody,
  PutMeUsersResponse,
  DeleteUsersParams,
  DeleteUsersResponse,
  PutUsersSetLangParams,
  PutUsersSetLangResponse

} from "./types";
import { List } from "api/slice/types";


export const UsersAPI = {
  getUsers: async (
    params: GetUsersParams
  ): Promise<AxiosResponse<GetUsersRes>> => {
    return await axiosApi.get<GetUsersRes>(`/users`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  getUsersLookup: async (
    params: GetUsersLookupParams
  ): Promise<AxiosResponse<List<GetUsersLookupResponse>>> => {
    return await axiosApi.get<List<GetUsersLookupResponse>>(
      `users/lookup`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      },
    );
  },
  getDisabledUsers: async (
    params: GetUsersParams
  ): Promise<AxiosResponse<GetUsersRes>> => {
    return await axiosApi.get<GetUsersRes>(`/users`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  getMeUsers: async (
    params: GetMeUsersParams
  ): Promise<AxiosResponse<GetMeUsersResponse>> => {
    return await axiosApi.get<GetMeUsersResponse>(`/users/me`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  getUsersWithoutPromocodes: async ({
    voucherId,
    ...params
  }: GetUsersWithoutPromocodesParams): Promise<AxiosResponse<GetUsersWithoutPromocodesResponse>> => {
    return await axiosApi.get<GetUsersWithoutPromocodesResponse>(`users/withoutPromocodes/${voucherId}`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  getUsersByUserId: async ({
    userId,
    ...params
  }: GetUsersByUserIdParams): Promise<AxiosResponse<GetUsersByUserIdResponse>> => {
    return await axios.get<GetUsersByUserIdResponse>(`users/${userId}`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  getUsersByAdmins: async (
    params: GetUsersParams
  ): Promise<AxiosResponse<GetUsersRes>> => {
    return await axiosApi.get<GetUsersRes>(`/users/admins`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  postUsers: async (
    body: PostUsersBody
  ): Promise<AxiosResponse<PostUsersResponse>> => {
    return await axiosApi.post<PostUsersResponse>(`/users`,
      body, {
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    }
    );
  },
  putUsers: async (
    body: PutUsersAsAdminBody
  ): Promise<AxiosResponse<PutUsersAsAdminResponse>> => {
    return await axiosApi.put<PutUsersAsAdminResponse>(
      `/users`,
      body, {
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  putMeUsers: async (
    body: PutMeUsersBody
  ): Promise<AxiosResponse<PutMeUsersResponse>> => {
    return await axiosApi.put<PutMeUsersResponse>(
      `/users/me`,
      body, {
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  deleteUsers: async ({
    userId,
    ...params
  }: DeleteUsersParams): Promise<AxiosResponse<DeleteUsersResponse>> => {
    return await axiosApi.delete<DeleteUsersResponse>(`users/${userId}`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  putUsersLanguage: async (
    params: PutUsersSetLangParams
  ): Promise<AxiosResponse<PutUsersSetLangResponse>> => {
    return await axiosApi.put<PutUsersSetLangResponse>(`/users/setLanguage`, {
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    })
  }
};